import { em } from 'polished'
import styled from 'styled-components'

import { Row, Col } from 'styles/components/layout'

export const RowStyled = styled(Row)`
  position: relative;
`

export const ColStyled = styled(Col)`
  text-align: center;
`

export const CheckboxWrapper = styled.div`
  margin-top: ${em(20)};
  margin-bottom: ${em(45)};
`
